import React from "react";
import Header from "../../Frontend/Shared/Header/Header";
import Sidebar from "../../Frontend/Shared/Sidebar";
import ScrollAnimation from "react-animate-on-scroll";
import Footer from "../../Frontend/Shared/Footer/Footer";
import ExternalLinksSlider from "../../Frontend/Shared/Footer/ExternalLinksSlider";

import SecunderabadRouting from "./SecunderabadRouting";

const SecunderabadLayout = ({ benchId, benchName, benchCode }) => {
  return (
    <>
      <Header benchId={benchId} benchName={benchName} benchCode={benchCode} />
      <div className="main-center-area">
        <div className="container-fluid">
          <div className="row">
            <Sidebar benchId={7} calendarId={benchId} />
            <SecunderabadRouting benchId={benchId} benchName={benchName} />
          </div>
        </div>
      </div>
      {/* <ScrollAnimation initiallyVisible={true} animateIn="fadeInRight">
        <ExternalLinksSlider benchId={benchId} />
      </ScrollAnimation> */}
      <Footer benchId={benchId} />
    </>
  );
};

export default SecunderabadLayout;
